const STATIC_FILES_URL = process.env.STATIC_FILES_URL || '/adout/static/'
export default STATIC_FILES_URL
